import { FC } from 'react';
// @ts-ignore
import ListGroup from 'jbc-front/components/ListGroup';
import { AdminUser, SingleEmployee } from 'jbc-front/components/icons';

import { dateOrTime } from '@jbc-year-end-adj/2024/utils/formatter';
import { useEmployeeQuery as useQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { FETCH_REQUEST_COMMENTS, QueryResult, RequestComment } from './query';
import { Employee } from '../../query';
import styles from './RequestComments.scss';

interface RequestCommentsProps {
  employee?: Employee;
}

export const RequestComments: FC<RequestCommentsProps> = ({ employee }) => {
  const { data } = useQuery<QueryResult>(FETCH_REQUEST_COMMENTS);

  if (!data) return null;

  const {
    request: { requestComments }
  } = data;

  return (
    <div className="l-flex">
      <div className={styles.commentBoxList}>
        <ListGroup>
          <ListGroup.Title>コメント</ListGroup.Title>
          {requestComments
            .filter(comment => !!comment.comment)
            .map(comment => (
              <ListGroup.Item key={comment.id}>
                <Comment comment={comment} employee={employee} />
              </ListGroup.Item>
            ))}
        </ListGroup>
      </div>
    </div>
  );
};

type CommentProps = {
  comment: RequestComment;
  employee?: Employee;
};

const Comment: FC<CommentProps> = ({ comment, employee }) => {
  switch (comment.commentBy) {
    case 'admin':
      return <AdminComment comment={comment} />;
    case 'employee':
      return <EmployeeComment comment={comment} employee={employee} />;
    default:
      return null;
  }
};

const AdminComment: FC<CommentProps> = ({ comment }) => {
  return (
    <div>
      <p>
        <AdminUser className={styles.commentIcon} />
        <span>{`管理者(${comment.actedUser ? comment.actedUser.name : '在籍していない管理者'})`}</span>
        <span className={styles.date}>{dateOrTime(comment.createdAt)}</span>
      </p>
      <p className={styles.comment}>{comment.comment}</p>
    </div>
  );
};

const EmployeeComment: FC<CommentProps> = ({ comment, employee }) => {
  return (
    <div>
      <p>
        <SingleEmployee className={styles.commentIcon} />
        {comment.commentBy === 'admin' ? (
          <span>{`管理者(${comment.actedUser ? comment.actedUser.name : '在籍していない管理者'})`}</span>
        ) : (
          <span>{`${employee?.profile.lastName} ${employee?.profile.firstName}`}</span>
        )}
        <span className={styles.date}>{dateOrTime(comment.createdAt)}</span>
      </p>
      <p className={styles.comment}>{comment.comment}</p>
    </div>
  );
};
